import { tenantApi as api } from '../config/api'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    downloadTrainingRecordsCsvExportJwt: build.query<
      DownloadTrainingRecordsCsvExportJwtApiResponse,
      DownloadTrainingRecordsCsvExportJwtApiArg
    >({
      query: (queryArg) => ({
        url: `/exports/training-records/csv/download`,
        params: {
          token: queryArg.token,
        },
      }),
    }),
    listTenantCourses: build.query<ListTenantCoursesApiResponse, ListTenantCoursesApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/courses` }),
    }),
    getTenantCourse: build.query<GetTenantCourseApiResponse, GetTenantCourseApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}` }),
    }),
    listTrainingCycles: build.query<ListTrainingCyclesApiResponse, ListTrainingCyclesApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles`,
        params: {
          status: queryArg.status,
          sort: queryArg.sort,
        },
      }),
    }),
    createTrainingCycle: build.mutation<CreateTrainingCycleApiResponse, CreateTrainingCycleApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles`,
        method: 'POST',
        body: queryArg.createTrainingCycleDto,
      }),
    }),
    deleteTrainingCycle: build.mutation<DeleteTrainingCycleApiResponse, DeleteTrainingCycleApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}`,
        method: 'DELETE',
      }),
    }),
    getTrainingCycle: build.query<GetTrainingCycleApiResponse, GetTrainingCycleApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}`,
      }),
    }),
    updateTrainingCycle: build.mutation<UpdateTrainingCycleApiResponse, UpdateTrainingCycleApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}`,
        method: 'PATCH',
        body: queryArg.updateTrainingCycleDto,
      }),
    }),
    listTrainingCycleEmails: build.query<ListTrainingCycleEmailsApiResponse, ListTrainingCycleEmailsApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/emails`,
      }),
    }),
    resetTrainingCycleEmail: build.mutation<ResetTrainingCycleEmailApiResponse, ResetTrainingCycleEmailApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/emails/${queryArg.notificationType}`,
        method: 'DELETE',
      }),
    }),
    resetTrainingCycleEmailLanguage: build.mutation<
      ResetTrainingCycleEmailLanguageApiResponse,
      ResetTrainingCycleEmailLanguageApiArg
    >({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/emails/${queryArg.notificationType}/${queryArg.languageTag}`,
        method: 'DELETE',
      }),
    }),
    saveTrainingCycleEmail: build.mutation<SaveTrainingCycleEmailApiResponse, SaveTrainingCycleEmailApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/emails/${queryArg.notificationType}/${queryArg.languageTag}`,
        method: 'PUT',
        body: queryArg.saveCycleEmailDto,
      }),
    }),
    sendTestTrainingCycleEmail: build.mutation<SendTestTrainingCycleEmailApiResponse, SendTestTrainingCycleEmailApiArg>(
      {
        query: (queryArg) => ({
          url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/emails/${queryArg.notificationType}/${queryArg.languageTag}/test`,
          method: 'POST',
          body: queryArg.saveCycleEmailDto,
        }),
      },
    ),
    listEnrollments: build.query<ListEnrollmentsApiResponse, ListEnrollmentsApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/enrollments`,
        params: {
          sort: queryArg.sort,
          search_term: queryArg.searchTerm,
          departments: queryArg.departments,
          locations: queryArg.locations,
          positions: queryArg.positions,
          units: queryArg.units,
          sources: queryArg.sources,
          statuses: queryArg.statuses,
          account_statuses: queryArg.accountStatuses,
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    createEnrollments: build.mutation<CreateEnrollmentsApiResponse, CreateEnrollmentsApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/enrollments`,
        method: 'POST',
        body: queryArg.createEnrollmentsDto,
      }),
    }),
    listEnrollmentFilterOptions: build.query<ListEnrollmentFilterOptionsApiResponse, ListEnrollmentFilterOptionsApiArg>(
      {
        query: (queryArg) => ({
          url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/enrollments/filter-options`,
        }),
      },
    ),
    removeEnrollments: build.mutation<RemoveEnrollmentsApiResponse, RemoveEnrollmentsApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/enrollments/unenroll`,
        method: 'POST',
        body: queryArg.removeEnrollmentsDto,
      }),
    }),
    forceCompleteEnrollment: build.mutation<ForceCompleteEnrollmentApiResponse, ForceCompleteEnrollmentApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/enrollments/${queryArg.enrollmentId}/force-completion`,
        method: 'POST',
        body: queryArg.forceCompletionInDto,
      }),
    }),
    previewTrainingCycleNextNotification: build.query<
      PreviewTrainingCycleNextNotificationApiResponse,
      PreviewTrainingCycleNextNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/next-notification`,
        params: {
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          notify_on_start: queryArg.notifyOnStart,
          reminder_enabled: queryArg.reminderEnabled,
          interval_days: queryArg.intervalDays,
          start_offset_days: queryArg.startOffsetDays,
          stop_rule: queryArg.stopRule,
          stop_on_date: queryArg.stopOnDate,
          stop_after_count: queryArg.stopAfterCount,
        },
      }),
    }),
    sendCycleReminder: build.mutation<SendCycleReminderApiResponse, SendCycleReminderApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/send-reminder`,
        method: 'POST',
      }),
    }),
    exportTrainingCycleRecordsPdf: build.mutation<
      ExportTrainingCycleRecordsPdfApiResponse,
      ExportTrainingCycleRecordsPdfApiArg
    >({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/cycles/${queryArg.cycleId}/training-records/export/pdf`,
        method: 'POST',
        body: queryArg.trainingRecordsExportInDto,
      }),
    }),
    getTenantCourseLanguages: build.query<GetTenantCourseLanguagesApiResponse, GetTenantCourseLanguagesApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/languages` }),
    }),
    previewNewTrainingCycleNextNotification: build.query<
      PreviewNewTrainingCycleNextNotificationApiResponse,
      PreviewNewTrainingCycleNextNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/next-notification`,
        params: {
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          notify_on_start: queryArg.notifyOnStart,
          reminder_enabled: queryArg.reminderEnabled,
          interval_days: queryArg.intervalDays,
          start_offset_days: queryArg.startOffsetDays,
          stop_rule: queryArg.stopRule,
          stop_on_date: queryArg.stopOnDate,
          stop_after_count: queryArg.stopAfterCount,
        },
      }),
    }),
    listTenantCourseVariants: build.query<ListTenantCourseVariantsApiResponse, ListTenantCourseVariantsApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/courses/${queryArg.courseCode}/variants` }),
    }),
    listEnrollmentGroupOptions: build.query<ListEnrollmentGroupOptionsApiResponse, ListEnrollmentGroupOptionsApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/enrollment-groups/options`,
        params: {
          filter_type: queryArg.filterType,
          search: queryArg.search,
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    previewEnrollmentGroups: build.query<PreviewEnrollmentGroupsApiResponse, PreviewEnrollmentGroupsApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/enrollment-groups/preview`,
        method: 'POST',
        body: queryArg.enrollmentGroupsPreviewRequestDto,
      }),
    }),
    createEnrollmentsBatch: build.mutation<CreateEnrollmentsBatchApiResponse, CreateEnrollmentsBatchApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/enrollments`, method: 'POST', body: queryArg.body }),
    }),
    removeEnrollmentsBatch: build.mutation<RemoveEnrollmentsBatchApiResponse, RemoveEnrollmentsBatchApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/enrollments/unenroll`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    exportGlobalTrainingRecordsCsv: build.mutation<
      ExportGlobalTrainingRecordsCsvApiResponse,
      ExportGlobalTrainingRecordsCsvApiArg
    >({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/global/training-records/export/csv`,
        method: 'POST',
        body: queryArg.trainingRecordsCsvExportInDto,
      }),
    }),
    listTenantTrainingCycles: build.query<ListTenantTrainingCyclesApiResponse, ListTenantTrainingCyclesApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/training-cycles`,
        params: {
          status: queryArg.status,
          course_code: queryArg.courseCode,
          sort: queryArg.sort,
        },
      }),
    }),
    exportTrainingRecordsCsv: build.mutation<ExportTrainingRecordsCsvApiResponse, ExportTrainingRecordsCsvApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/training-records/export/csv`,
        method: 'POST',
        body: queryArg.trainingRecordsCsvExportInDto,
      }),
    }),
    getMyTrainingRecordsExportStatus: build.query<
      GetMyTrainingRecordsExportStatusApiResponse,
      GetMyTrainingRecordsExportStatusApiArg
    >({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/training-records/export/csv/me/status` }),
    }),
    getTrainingRecordsCsvExportStatus: build.query<
      GetTrainingRecordsCsvExportStatusApiResponse,
      GetTrainingRecordsCsvExportStatusApiArg
    >({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/training-records/export/csv/${queryArg.exportId}` }),
    }),
    downloadTrainingRecordsCsvExport: build.query<
      DownloadTrainingRecordsCsvExportApiResponse,
      DownloadTrainingRecordsCsvExportApiArg
    >({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/training-records/export/csv/${queryArg.exportId}/download`,
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as enhancedApi }
export type DownloadTrainingRecordsCsvExportJwtApiResponse = /** status 200 Successful Response */ null
export type DownloadTrainingRecordsCsvExportJwtApiArg = {
  /** JWT token containing export_id */
  token: string
}
export type ListTenantCoursesApiResponse = /** status 200 Successful Response */ TenantCourseDto[]
export type ListTenantCoursesApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
}
export type GetTenantCourseApiResponse = /** status 200 Successful Response */ TenantCourseDto
export type GetTenantCourseApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
}
export type ListTrainingCyclesApiResponse = /** status 200 Successful Response */ TrainingCycleListItemDto[]
export type ListTrainingCyclesApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** Filter by TrainingCycleStatus value. */
  status?: TrainingCycleStatusFilter
  /** Reserved, not implemented yet; responses always use the default 'ending soon' ordering (end_date ascending). */
  sort?: string
}
export type CreateTrainingCycleApiResponse = /** status 200 Successful Response */ CreatedTrainingCycleDto
export type CreateTrainingCycleApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  createTrainingCycleDto: CreateTrainingCycleDto
}
export type DeleteTrainingCycleApiResponse = unknown
export type DeleteTrainingCycleApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
}
export type GetTrainingCycleApiResponse = /** status 200 Successful Response */ TrainingCycleWithGroupsDto
export type GetTrainingCycleApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
}
export type UpdateTrainingCycleApiResponse = /** status 200 Successful Response */ UpdatedTrainingCycleDto
export type UpdateTrainingCycleApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  updateTrainingCycleDto: UpdateTrainingCycleDto
}
export type ListTrainingCycleEmailsApiResponse = /** status 200 Successful Response */ CycleEmailDto[]
export type ListTrainingCycleEmailsApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
}
export type ResetTrainingCycleEmailApiResponse = unknown
export type ResetTrainingCycleEmailApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  /** The email: enrolment or reminder. */
  notificationType: CycleEmailType
}
export type ResetTrainingCycleEmailLanguageApiResponse = unknown
export type ResetTrainingCycleEmailLanguageApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  /** The email: enrolment or reminder. */
  notificationType: CycleEmailType
  /** The language of the cycle's wording. */
  languageTag: CycleEmailLanguage
}
export type SaveTrainingCycleEmailApiResponse = /** status 200 Successful Response */ CycleEmailDto
export type SaveTrainingCycleEmailApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  /** The email: enrolment or reminder. */
  notificationType: CycleEmailType
  /** The language of the cycle's wording. */
  languageTag: CycleEmailLanguage
  saveCycleEmailDto: SaveCycleEmailDto
}
export type SendTestTrainingCycleEmailApiResponse = unknown
export type SendTestTrainingCycleEmailApiArg = {
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  /** The email: enrolment or reminder. */
  notificationType: CycleEmailType
  /** The language of the cycle's wording. */
  languageTag: CycleEmailLanguage
  saveCycleEmailDto: SaveCycleEmailDto
}
export type ListEnrollmentsApiResponse = /** status 200 Successful Response */ PageEnrollmentListItemDto
export type ListEnrollmentsApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  /** Single column to order by, a leading `-` meaning descending. Enrollments with no completion date sort last on `completed_at` in either direction. When unset, the default order is: completed enrollments by completion date, then the rest by enrolment date, both latest first, then alphabetically by last then first name. Ordering is applied across the whole cycle before pagination, under a deterministic tie-break, so no row appears on two pages or none. */
  sort?: EnrollmentSort
  /** Filters by learner name or email, applied before ordering and pagination, so it composes with `sort`. */
  searchTerm?: string
  /** The departments to filter the roster to. Pass '__EMPTY__' to include learners with no department set; it combines with real values as OR, so both sets come back together. Applied before ordering and pagination, scoped to this cycle. */
  departments?: string[]
  /** The locations to filter the roster to. Pass '__EMPTY__' to include learners with no location set; it combines with real values as OR. */
  locations?: string[]
  /** The positions to filter the roster to. Pass '__EMPTY__' to include learners with no position set; it combines with real values as OR. */
  positions?: string[]
  /** The unit ids to filter the roster to; a learner in any of them matches. Pass '__EMPTY__' to include learners in no unit; it combines with unit ids as OR. */
  units?: string[]
  /** The enrolment sources to filter the roster to. */
  sources?: EnrollmentSource[]
  /** The enrolment statuses to filter the roster to. */
  statuses?: EnrollmentStatus[]
  /** The learner account states to filter the roster to. Selecting 'Deleted' is the only way to retrieve learners whose identity has been removed from the provider: they carry no profile fields, so `search_term` never matches them. */
  accountStatuses?: RosterAccountStatus[]
  page?: number
  size?: number
}
export type CreateEnrollmentsApiResponse = /** status 200 Successful Response */ EnrollmentAssignmentResultDto
export type CreateEnrollmentsApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  createEnrollmentsDto: CreateEnrollmentsDto
}
export type ListEnrollmentFilterOptionsApiResponse = /** status 200 Successful Response */ EnrollmentFilterOptionsDto
export type ListEnrollmentFilterOptionsApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
}
export type RemoveEnrollmentsApiResponse = /** status 200 Successful Response */ RemoveEnrollmentsResultDto
export type RemoveEnrollmentsApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  removeEnrollmentsDto: RemoveEnrollmentsDto
}
export type ForceCompleteEnrollmentApiResponse = /** status 200 Successful Response */ null
export type ForceCompleteEnrollmentApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  /** EnrollmentListItemDto.enrollment_id. */
  enrollmentId: string
  forceCompletionInDto: ForceCompletionInDto
}
export type PreviewTrainingCycleNextNotificationApiResponse = /** status 200 Successful Response */ NotificationSchedule
export type PreviewTrainingCycleNextNotificationApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  startDate?: string
  endDate?: string
  notifyOnStart?: boolean
  reminderEnabled?: boolean
  intervalDays?: number
  startOffsetDays?: number
  stopRule?: ReminderStopRule
  stopOnDate?: string
  stopAfterCount?: number
}
export type SendCycleReminderApiResponse = /** status 202 Successful Response */ SendReminderAcceptedDto
export type SendCycleReminderApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
}
export type ExportTrainingCycleRecordsPdfApiResponse = /** status 200 Successful Response */ TrainingRecordsExportOutDto
export type ExportTrainingCycleRecordsPdfApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  /** TrainingCycleDto.id. */
  cycleId: string
  trainingRecordsExportInDto: TrainingRecordsExportInDto
}
export type GetTenantCourseLanguagesApiResponse = /** status 200 Successful Response */ TenantCourseLanguagesDto
export type GetTenantCourseLanguagesApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
}
export type PreviewNewTrainingCycleNextNotificationApiResponse =
  /** status 200 Successful Response */ NotificationSchedule
export type PreviewNewTrainingCycleNextNotificationApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
  startDate: string
  endDate: string
  notifyOnStart?: boolean
  reminderEnabled?: boolean
  intervalDays?: number
  startOffsetDays?: number
  stopRule?: ReminderStopRule
  stopOnDate?: string
  stopAfterCount?: number
}
export type ListTenantCourseVariantsApiResponse = /** status 200 Successful Response */ CourseVariantDto[]
export type ListTenantCourseVariantsApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Stable course business key; paths address courses by code, not id. */
  courseCode: string
}
export type ListEnrollmentGroupOptionsApiResponse = /** status 200 Successful Response */ PageGroupOptionDto
export type ListEnrollmentGroupOptionsApiArg = {
  tenantId: string
  filterType: GroupFilterType
  /** Case-insensitive substring of the label. */
  search?: string
  page?: number
  size?: number
}
export type PreviewEnrollmentGroupsApiResponse = /** status 200 Successful Response */ EnrollmentGroupsPreviewDto
export type PreviewEnrollmentGroupsApiArg = {
  tenantId: string
  enrollmentGroupsPreviewRequestDto: EnrollmentGroupsPreviewRequestDto
}
export type CreateEnrollmentsBatchApiResponse = /** status 200 Successful Response */ BatchEnrollmentResultDto[]
export type CreateEnrollmentsBatchApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  body: BatchEnrollmentEntryDto[]
}
export type RemoveEnrollmentsBatchApiResponse = /** status 200 Successful Response */ BatchRemovalResultDto[]
export type RemoveEnrollmentsBatchApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  body: BatchRemovalEntryDto[]
}
export type ExportGlobalTrainingRecordsCsvApiResponse = /** status 202 Successful Response */ CsvExportResponseDto
export type ExportGlobalTrainingRecordsCsvApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  trainingRecordsCsvExportInDto: TrainingRecordsCsvExportInDto
}
export type ListTenantTrainingCyclesApiResponse = /** status 200 Successful Response */ TrainingCycleListItemDto[]
export type ListTenantTrainingCyclesApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** Filter by lifecycle status; repeatable. Only planned|running|ended; archived is rejected (422). */
  status?: TrainingCycleStatusFilter[]
  /** Optional course business key; narrows the list to a single course. */
  courseCode?: string
  /** Reserved, not implemented yet; responses always use the default 'ending soon' ordering (end_date ascending). */
  sort?: string
}
export type ExportTrainingRecordsCsvApiResponse = /** status 202 Successful Response */ CsvExportResponseDto
export type ExportTrainingRecordsCsvApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  trainingRecordsCsvExportInDto: TrainingRecordsCsvExportInDto
}
export type GetMyTrainingRecordsExportStatusApiResponse = /** status 200 Successful Response */ CsvExportStatusDto
export type GetMyTrainingRecordsExportStatusApiArg = {
  tenantId: string
}
export type GetTrainingRecordsCsvExportStatusApiResponse = /** status 200 Successful Response */ CsvExportRequestModel
export type GetTrainingRecordsCsvExportStatusApiArg = {
  exportId: string
  tenantId: string
}
export type DownloadTrainingRecordsCsvExportApiResponse = /** status 200 Successful Response */ null
export type DownloadTrainingRecordsCsvExportApiArg = {
  exportId: string
  tenantId: string
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type TenantCourseAvailability = 'available' | 'access_removed' | 'unavailable'
export type ReminderStopRule = 'end_of_cycle' | 'on_date' | 'after_count'
export type ReminderConfig = {
  /** Days between reminder sends. */
  interval_days?: number
  /** Master switch; the remaining fields only apply when true. */
  reminder_enabled: boolean
  /** Days after cycle start that the reminder days are counted from. Every learner still gets a full interval of grace after the cycle opens, so an offset shorter than the interval moves the days reminders can fall on without moving the first one. */
  start_offset_days?: number
  /** Reminders stop after this many sends when stop_rule is after_count. */
  stop_after_count?: number
  /** Reminders stop on this date when stop_rule is on_date. */
  stop_on_date?: string
  /** When reminders stop; selects which stop_* field applies. */
  stop_rule?: ReminderStopRule
}
export type CourseConfigDefaultsDto = {
  /** Client-side reminder prefill for new cycles; never applied server-side. */
  default: ReminderConfig
  /** Client-side prefill: days after cycle start for a new cycle's due date; never applied server-side — cycles created on this surface store due_date as null. */
  default_due_offset_days?: number
  /** Client-side prefill for a new cycle's notify_on_start; never applied server-side. */
  default_notify_on_start: boolean
  /** Course-config id; TrainingCycleDto.course_config_id references it. */
  id: string
}
export type TenantCourseDto = {
  /** Non-archived cycles currently running; planned and ended cycles are not counted. */
  active_cycle_count: number
  /** What the tenant may still do with this course; computed per request from the entitlement predicate, never stored. */
  availability: TenantCourseAvailability
  /** The tenant's stored setup for this course; null until it has been set up, which is the normal state of a newly provisioned course. */
  config?: CourseConfigDefaultsDto
  course_code: string
  course_id: string
  /** Variant title in the requester's language, falling back to the course's internal name and then its code; never null. */
  course_name: string
  /** The course's length in minutes, as learner emails show it. */
  duration_in_minutes: number
}
export type TrainingCycleGuardErrorCode =
  | 'end_before_start'
  | 'start_in_past'
  | 'overlap_conflict'
  | 'auto_repeat_end_date_guard'
  | 'not_editable_in_status'
  | 'invalid_reminder_config'
  | 'course_not_entitled'
  | 'not_deletable'
  | 'course_not_found'
  | 'cycle_not_found'
  | 'cycle_not_running'
  | 'manual_send_cooldown'
  | 'duplicate_cycle_name'
  | 'cycle_name_required'
  | 'concurrent_group_change'
  | 'unit_group_unavailable'
  | 'cycle_emails_read_only'
  | 'cycle_email_content_invalid'
export type DomainErrorDtoTrainingCycleGuardErrorCode = {
  error_code: TrainingCycleGuardErrorCode
  message: string
}
export type TrainingCycleStatus = 'planned' | 'running' | 'ended' | 'archived'
export type TrainingCycleListItemDto = {
  /** Enrollments completed in this cycle. */
  completed_count: number
  /** Completed enrollments as a percentage of total_count. */
  completion_percentage: number
  /** Stable course business key this cycle belongs to. */
  course_code: string
  /** TenantCourseDto.config.id this cycle was created under. */
  course_config_id: string
  /** Display name of the cycle's course. */
  course_name: string
  /** Cycle this one was auto-created from on renewal; null for manually created cycles. */
  created_from_cycle_id?: string
  /** Always null for cycles created on this surface (never derived server-side); populated only on migrated legacy cycles. */
  due_date?: string
  end_date: string
  id: string
  /** Whether the tenant is still entitled to the cycle's course. */
  is_available: boolean
  /** When a manual reminder may next be sent for this cycle. Null means one may be sent now; a timestamp means the cooldown is still running and a send would be refused with 429 manual_send_cooldown until then. Only successful and in-flight sends hold the cooldown - one that failed does not. */
  manual_send_available_at?: string
  name?: string
  /** When the cycle's next automatic reminder run is scheduled: the next tick from the cycle's reference day, at 08:00 UTC on that day or the following Monday. Null when reminders are off or nothing further is scheduled. A learner who joined, or was last reminded, fewer than interval days before the tick is picked up on the following one, and the per-learner exclusions (completed, archived, still owed a start, stop-after-count reached) apply as usual. */
  next_reminder_at?: string
  /** When the start notification is scheduled to go out: 08:00 UTC on start_date. Null unless the cycle is planned with notify_on_start on. */
  next_start_notification_at?: string
  notify_on_start: boolean
  reminder_config: ReminderConfig
  start_date: string
  /** Lifecycle state; governs which fields may be updated and whether the cycle can be deleted. */
  status: TrainingCycleStatus
  /** The name saved on the cycle; null when it has none and `name` is the course-name-and-start-year fallback. Learner emails build that fallback from the course title in each learner's language, so an email preview needs to tell the two apart. */
  stored_name?: string
  /** All enrollments in this cycle. */
  total_count: number
}
export type TrainingCycleStatusFilter = 'planned' | 'running' | 'ended'
export type AssignmentErrorCode = 'overlap_conflict' | 'not_in_tenant' | 'already_enrolled' | 'cycle_ended'
export type EnrollmentSkip = {
  /** Why the user was not enrolled. */
  code: AssignmentErrorCode
  /** Last day of the conflicting cycle's window, inclusive; set with conflicting_cycle_id, null otherwise. */
  conflicting_cycle_end_date?: string
  /** Cycle the learner is already enrolled in; set when code is overlap_conflict, null otherwise. For navigation/dedup. */
  conflicting_cycle_id?: string
  /** Display name of the conflicting cycle, so the failure list names it without a lookup; set with conflicting_cycle_id, null when code is not overlap_conflict. A cycle with no name of its own is named by its course and start year, as everywhere else, so this is never an id. */
  conflicting_cycle_name?: string
  /** First day of the conflicting cycle's window; set with conflicting_cycle_id, null otherwise. */
  conflicting_cycle_start_date?: string
  /** Lifecycle of the conflicting cycle, so a running conflict reads apart from one that has not started; set with conflicting_cycle_id, null otherwise. Only planned and running cycles conflict, so ended never appears here. */
  conflicting_cycle_status?: TrainingCycleStatus
  /** Learner email; null when unknown. */
  email?: string
  /** Learner given name, so the failure list is self-contained even for group enrolments; null when the user could not be resolved (not_in_tenant). */
  first_name?: string
  /** Learner family name; null when the user could not be resolved. */
  last_name?: string
  user_id: string
}
export type CycleEnrollmentResultDto = {
  enrolled_count: number
  /** Group members who were not enrolled, each with the reason. */
  skipped: EnrollmentSkip[]
}
export type GroupFilterType = 'department' | 'location' | 'position' | 'unit'
export type TrainingCycleGroupDto = {
  /** Learners in the cycle with source `group` who currently match this group. Enrolments are not linked to the group that created them, so removing the group with `unenroll` can remove fewer learners than this: one also matching another of the cycle's groups stays. */
  enrolled_count: number
  filter_type: GroupFilterType
  /** Spelling to show; the unit name for units. */
  label: string
  /** Learners in the group now. */
  member_count: number
  /** True for a unit group whose unit was deleted; `label` is still the unit's name. */
  unit_deleted?: boolean
  /** Folded value; a unit id for units. */
  value: string
}
export type CreatedTrainingCycleDto = {
  /** TenantCourseDto.config.id this cycle was created under. */
  course_config_id: string
  /** Cycle this one was auto-created from on renewal; null for manually created cycles. */
  created_from_cycle_id?: string
  /** Always null for cycles created on this surface (never derived server-side); populated only on migrated legacy cycles. */
  due_date?: string
  end_date: string
  enrollment_result: CycleEnrollmentResultDto
  /** Groups the cycle enrols from, with their current member counts. */
  groups?: TrainingCycleGroupDto[]
  id: string
  /** Whether the tenant is still entitled to the cycle's course. */
  is_available: boolean
  /** When a manual reminder may next be sent for this cycle. Null means one may be sent now; a timestamp means the cooldown is still running and a send would be refused with 429 manual_send_cooldown until then. Only successful and in-flight sends hold the cooldown - one that failed does not. */
  manual_send_available_at?: string
  name?: string
  /** When the cycle's next automatic reminder run is scheduled: the next tick from the cycle's reference day, at 08:00 UTC on that day or the following Monday. Null when reminders are off or nothing further is scheduled. A learner who joined, or was last reminded, fewer than interval days before the tick is picked up on the following one, and the per-learner exclusions (completed, archived, still owed a start, stop-after-count reached) apply as usual. */
  next_reminder_at?: string
  /** When the start notification is scheduled to go out: 08:00 UTC on start_date. Null unless the cycle is planned with notify_on_start on. */
  next_start_notification_at?: string
  notify_on_start: boolean
  reminder_config: ReminderConfig
  start_date: string
  /** Lifecycle state; governs which fields may be updated and whether the cycle can be deleted. */
  status: TrainingCycleStatus
  /** The name saved on the cycle; null when it has none and `name` is the course-name-and-start-year fallback. Learner emails build that fallback from the course title in each learner's language, so an email preview needs to tell the two apart. */
  stored_name?: string
}
export type GroupRefDto = {
  filter_type: GroupFilterType
  value: string
}
export type CreateTrainingCycleDto = {
  end_date: string
  /** Groups whose current members are enrolled when the cycle is created. Each learner is enrolled once, however many groups they match. */
  groups?: GroupRefDto[]
  name: string
  notify_on_start: boolean
  reminder_config: ReminderConfig
  start_date: string
}
export type TrainingCycleWithGroupsDto = {
  /** TenantCourseDto.config.id this cycle was created under. */
  course_config_id: string
  /** Cycle this one was auto-created from on renewal; null for manually created cycles. */
  created_from_cycle_id?: string
  /** Always null for cycles created on this surface (never derived server-side); populated only on migrated legacy cycles. */
  due_date?: string
  end_date: string
  /** Groups the cycle enrols from, with their current member counts. */
  groups?: TrainingCycleGroupDto[]
  id: string
  /** Whether the tenant is still entitled to the cycle's course. */
  is_available: boolean
  /** When a manual reminder may next be sent for this cycle. Null means one may be sent now; a timestamp means the cooldown is still running and a send would be refused with 429 manual_send_cooldown until then. Only successful and in-flight sends hold the cooldown - one that failed does not. */
  manual_send_available_at?: string
  name?: string
  /** When the cycle's next automatic reminder run is scheduled: the next tick from the cycle's reference day, at 08:00 UTC on that day or the following Monday. Null when reminders are off or nothing further is scheduled. A learner who joined, or was last reminded, fewer than interval days before the tick is picked up on the following one, and the per-learner exclusions (completed, archived, still owed a start, stop-after-count reached) apply as usual. */
  next_reminder_at?: string
  /** When the start notification is scheduled to go out: 08:00 UTC on start_date. Null unless the cycle is planned with notify_on_start on. */
  next_start_notification_at?: string
  notify_on_start: boolean
  reminder_config: ReminderConfig
  start_date: string
  /** Lifecycle state; governs which fields may be updated and whether the cycle can be deleted. */
  status: TrainingCycleStatus
  /** The name saved on the cycle; null when it has none and `name` is the course-name-and-start-year fallback. Learner emails build that fallback from the course title in each learner's language, so an email preview needs to tell the two apart. */
  stored_name?: string
}
export type UpdatedTrainingCycleDto = {
  /** TenantCourseDto.config.id this cycle was created under. */
  course_config_id: string
  /** Cycle this one was auto-created from on renewal; null for manually created cycles. */
  created_from_cycle_id?: string
  /** Always null for cycles created on this surface (never derived server-side); populated only on migrated legacy cycles. */
  due_date?: string
  end_date: string
  enrollment_result: CycleEnrollmentResultDto
  /** Groups the cycle enrols from, with their current member counts. */
  groups?: TrainingCycleGroupDto[]
  id: string
  /** Whether the tenant is still entitled to the cycle's course. */
  is_available: boolean
  /** When a manual reminder may next be sent for this cycle. Null means one may be sent now; a timestamp means the cooldown is still running and a send would be refused with 429 manual_send_cooldown until then. Only successful and in-flight sends hold the cooldown - one that failed does not. */
  manual_send_available_at?: string
  name?: string
  /** When the cycle's next automatic reminder run is scheduled: the next tick from the cycle's reference day, at 08:00 UTC on that day or the following Monday. Null when reminders are off or nothing further is scheduled. A learner who joined, or was last reminded, fewer than interval days before the tick is picked up on the following one, and the per-learner exclusions (completed, archived, still owed a start, stop-after-count reached) apply as usual. */
  next_reminder_at?: string
  /** When the start notification is scheduled to go out: 08:00 UTC on start_date. Null unless the cycle is planned with notify_on_start on. */
  next_start_notification_at?: string
  notify_on_start: boolean
  reminder_config: ReminderConfig
  start_date: string
  /** Lifecycle state; governs which fields may be updated and whether the cycle can be deleted. */
  status: TrainingCycleStatus
  /** The name saved on the cycle; null when it has none and `name` is the course-name-and-start-year fallback. Learner emails build that fallback from the course title in each learner's language, so an email preview needs to tell the two apart. */
  stored_name?: string
  /** Learners unenrolled by this update's `unenroll` group removals; 0 when no group was removed or every removal said `keep`. */
  unenrolled_count: number
}
export type GroupRemovalAction = 'keep' | 'unenroll'
export type GroupRemovalDto = {
  filter_type: GroupFilterType
  on_remove: GroupRemovalAction
  value: string
}
export type UpdateTrainingCycleDto = {
  /** Null leaves the field unchanged. */
  end_date?: string
  /** Groups to add to the cycle; their current members are enrolled in the same request. Each learner is enrolled once, however many groups they match; a group already on the cycle is ignored. Refused (422 not_editable_in_status) when the cycle has ended. */
  groups_added?: GroupRefDto[]
  /** Groups to take off the cycle, each deciding the fate of the group-sourced learners who match none of the cycle's remaining groups: `keep` leaves them enrolled as individual (`manual`) enrolments that no later group removal can sweep; `unenroll` removes the uncompleted ones. `keep` wins ambiguity: beside a `keep`, an `unenroll` only removes learners its group still covers. Completed and individually enrolled learners always stay. Removals apply after any `groups_added`, so one request can swap groups. */
  groups_removed?: GroupRemovalDto[]
  /** Null leaves the field unchanged. A name cannot be removed once set: blank is rejected, so a cycle can be renamed but never returned to the derived course name + start year. */
  name?: string
  /** Null leaves the field unchanged. Editable in any status but ended; switching it back on for a running cycle only notifies learners assigned from then on. */
  notify_on_start?: boolean
  /** Null leaves the field unchanged. */
  reminder_config?: ReminderConfig
  /** Editable only while status is planned (422 otherwise); null leaves the field unchanged. */
  start_date?: string
}
export type CycleEmailLanguage = 'en-GB' | 'de-DE'
export type CycleEmailType = 'INVITATION' | 'REMINDER'
export type CycleEmailEditorDto = {
  id: string
  /** Full name; null when the account no longer exists. */
  name?: string | null
}
export type CycleEmailDto = {
  /** The editable body (#email-content) as HTML; the frame around it comes from the lawpilots template. */
  body: string
  language_tag: CycleEmailLanguage
  notification_type: CycleEmailType
  subject: string
  updated_at: string
  updated_by: CycleEmailEditorDto
}
export type PlaceholderField = 'subject' | 'body'
export type PlaceholderErrorReason = 'unknown' | 'not_allowed_in_subject' | 'frame_only' | 'broken' | 'required'
export type CycleEmailContentErrorDto = {
  field: PlaceholderField
  reason: PlaceholderErrorReason
  /** The placeholder to write instead of a retired one. */
  replacement: string | null
  /** The placeholder or stray braces as written; null when the field is empty. */
  token: string | null
}
export type CycleEmailContentInvalidDto = {
  error_code: TrainingCycleGuardErrorCode
  errors: CycleEmailContentErrorDto[]
  message: string
}
export type SaveCycleEmailDto = {
  /** The editable body (#email-content) as HTML. */
  body: string
  subject: string
}
export type RosterAccountStatus = 'Active' | 'Inactive' | 'Pending' | 'Disabled' | 'Deleted'
export type EnrollmentStatus = 'invited' | 'in_progress' | 'completed'
export type EnrollmentSource = 'manual' | 'group' | 'auto_follow_up' | 'migrated'
export type UnitBasicDto = {
  id: string
  name: string
}
export type EnrollmentListItemDto = {
  /** The learner's account. Deleted means the identity is gone from the provider while the enrollment and its training record remain; such a row carries no profile fields, never matches search_term, and sorts last on the name orders. */
  account_status: RosterAccountStatus
  /** Certificate for the completion, as accepted by the certificate regeneration endpoint; null while not completed. */
  certificate_id?: string
  /** When the certificate was last manually regenerated; null when never. */
  certificate_manually_regenerated_at?: string
  /** A stable tenant-authorised download URL for the certificate PDF (not an expiring presigned link); treat it as opaque. Null while not completed, and null while completed until the PDF has been stored; a non-null URL can still 404 if the stored object has since gone, so pair it with certificate_id rather than reading it as a guarantee. */
  certificate_url?: string
  /** When the learner completed the cycle's course; null while not completed. */
  completed_at?: string
  department?: string
  email?: string
  employee_id?: string
  /** When the learner was enrolled into the cycle. */
  enrolled_at: string
  /** The enrollment row this entry came from. A stable row key; the write routes on this surface are keyed on user_id, so this addresses no operation. Unique per row, unlike user_id, which repeats once a learner holds an archived enrollment alongside a live one. */
  enrollment_id: string
  enrollment_status: EnrollmentStatus
  first_name?: string
  /** True when the completion was recorded manually by an admin rather than by finishing the course. */
  is_manually_completed?: boolean
  last_name?: string
  /** Most recent invitation or reminder sent to the learner; null when never notified. */
  last_notified_at?: string
  location?: string
  position?: string
  /** How the enrollment was created. */
  source: EnrollmentSource
  /** Units the learner belongs to; empty when none. Display only: not a sort key and not matched by search_term. */
  units?: UnitBasicDto[]
  user_id: string
}
export type PageEnrollmentListItemDto = {
  items: EnrollmentListItemDto[]
  page?: number
  pages?: number
  size?: number
  total?: number
}
export type EnrollmentSort =
  | 'first_name'
  | '-first_name'
  | 'last_name'
  | '-last_name'
  | 'completed_at'
  | '-completed_at'
  | 'department'
  | '-department'
  | 'location'
  | '-location'
  | 'position'
  | '-position'
  | 'source'
  | '-source'
  | 'last_notified_at'
  | '-last_notified_at'
  | 'enrollment_status'
  | '-enrollment_status'
export type EnrollmentAssignmentResultDto = {
  /** User ids newly enrolled. */
  assigned: string[]
  /** Users not enrolled, each with a reason code. Together with assigned this accounts for every requested user id: a learner already in the cycle reports as already_enrolled rather than being dropped. */
  skipped: EnrollmentSkip[]
}
export type DomainErrorDtoAssignmentErrorCode = {
  error_code: AssignmentErrorCode
  message: string
}
export type CreateEnrollmentsDto = {
  user_ids: string[]
}
export type EnrollmentFilterOptionsDto = {
  account_statuses: RosterAccountStatus[]
  departments: string[]
  locations: string[]
  positions: string[]
  sources: EnrollmentSource[]
  statuses: EnrollmentStatus[]
  units: UnitBasicDto[]
}
export type RemovalErrorCode = 'not_enrolled' | 'already_completed' | 'not_in_tenant'
export type EnrollmentRemovalSkip = {
  /** Why the learner was not unenrolled. */
  code: RemovalErrorCode
  user_id: string
}
export type RemoveEnrollmentsResultDto = {
  /** User ids unenrolled from the cycle. */
  removed: string[]
  /** Users not unenrolled, each with a reason code. */
  skipped: EnrollmentRemovalSkip[]
}
export type RemoveEnrollmentsDto = {
  /** Learners to unenroll from the cycle; a single-element list covers the single-learner case. Operates on existing individual enrollments (no group expansion). */
  user_ids: string[]
}
export type ForceCompletionInDto = {
  /** The date the learner is recorded as having finished. */
  completion_date: string
}
export type NotificationSchedule = {
  next_reminder_at?: string
  next_start_notification_at?: string
}
export type SendReminderAcceptedDto = {
  /** When the manual reminder send was accepted and queued; drives the 'last sent' state and the manual-send cooldown. The send itself is performed asynchronously after this response. */
  accepted_at: string
  /** Learners left out of this send because an earlier manual send of theirs has not settled yet and is still owed to them, so sending again would mail them twice. They are not skipped for good: the reclaim sweep delivers the earlier attempt, or abandons it and they become reachable again. Present so a recipient_count smaller than the incomplete-learner count is explainable to the person who clicked. */
  already_queued_count?: number
  /** Learners targeted at acceptance time (the not-yet-completed enrollments when the send was accepted); actual sends may be fewer if enrollment state changes before the queued send runs. */
  recipient_count: number
  /** Opaque handle for the accepted send. Reserves a future status lookup; treat as opaque. */
  reminder_job_id: string
  /** Learners left out because their identity no longer exists in the provider, so there is no address to reach them at. Their enrollments still appear on the Learners tab as Deleted accounts. Unlike already_queued_count these are permanent: the occurrence is settled rather than retried. */
  skipped_no_identity_count?: number
}
export type TrainingRecordsExportOutDto = {
  success: boolean
  /** Presigned download URL for the PDF; null on failure. */
  url?: string
}
export type TrainingRecordsExportInDto = {
  /** Language the PDF is rendered in. Falls back to the requester's language, then de-DE; an unsupported tag renders de-DE. */
  language_tag?: string
  /** True (default) exports the completion evidence alone; false exports the whole roster, uncompleted learners with an empty completion date. Same switch as the legacy participations export. */
  only_completed?: boolean
}
export type TenantCourseLanguagesDto = {
  /** Language tags whose adapted version is published. */
  adapted: string[]
  /** Language tags provisioned but not published in any version. */
  in_translation: string[]
  /** Language tags published in the standard version only; includes tags whose bought adaptation is not published yet. */
  standard: string[]
}
export type FormOfAddress = 'formal' | 'informal' | 'not_applicable'
export type CourseVariantDto = {
  created_at?: string
  description: string
  easy_language: boolean
  form_of_address: FormOfAddress
  id: string
  language_display_name: string
  language_tag: string
  learning_objectives: string[]
  low_vision: boolean
  tenant_id?: string
  tenant_name?: string
  title: string
  updated_at?: string
  wcag: boolean
}
export type GroupOptionDto = {
  /** Spelling to show the Learning Manager. */
  label: string
  /** Learners who hold this value. */
  learner_count: number
  /** Folded value to form the group from; a unit id for units. */
  value: string
}
export type PageGroupOptionDto = {
  items: GroupOptionDto[]
  page?: number
  pages?: number
  size?: number
  total?: number
}
export type EnrollmentGroupsPreviewDto = {
  /** Matched learners already in another planned or running cycle of the course; excluded from total. */
  conflicts: number
  /** Sum of the per-group learner counts minus the distinct union; learners in more than one group are enrolled once. */
  overlap: number
  /** Distinct learners the groups match who would actually be enrolled. */
  total: number
}
export type EnrollmentGroupsPreviewRequestDto = {
  /** Stable course business key of the course the cycle belongs to; conflicts are counted against its other cycles. */
  course_code: string
  /** Cycle being edited, if any; its members are left out of every count and it is never a conflict. */
  cycle_id?: string
  /** Groups the cycle would enrol; the preview counts the distinct learners of their union. */
  groups: GroupRefDto[]
}
export type EnrollmentBatchErrorCode =
  | 'cycle_not_found'
  | 'course_not_found'
  | 'course_not_entitled'
  | 'cycle_ended'
  | 'entry_failed'
export type DomainErrorDtoEnrollmentBatchErrorCode = {
  error_code: EnrollmentBatchErrorCode
  message: string
}
export type BatchEnrollmentResultDto = {
  /** User ids newly enrolled. */
  assigned: string[]
  /** Cycle this result belongs to. */
  cycle_id: string
  /** Set when is_successful is false, null otherwise. */
  error?: DomainErrorDtoEnrollmentBatchErrorCode
  /** False when the entry could not be attempted; the assigned and skipped lists are then empty and error explains why. */
  is_successful: boolean
  /** Users not enrolled, each with a reason code. Together with assigned this accounts for every requested user id: a learner already in the cycle reports as already_enrolled rather than being dropped. */
  skipped: EnrollmentSkip[]
}
export type BatchEnrollmentEntryDto = {
  /** Cycle to enrol into. Its course is resolved server-side, so no course code is sent. */
  cycle_id: string
  user_ids: string[]
}
export type BatchRemovalResultDto = {
  /** Cycle this result belongs to. */
  cycle_id: string
  /** Set when is_successful is false, null otherwise. */
  error?: DomainErrorDtoEnrollmentBatchErrorCode
  /** False when the entry could not be attempted; the removed and skipped lists are then empty and error explains why. */
  is_successful: boolean
  /** User ids unenrolled from the cycle. */
  removed: string[]
  /** Users not unenrolled, each with a reason code. */
  skipped: EnrollmentRemovalSkip[]
}
export type BatchRemovalEntryDto = {
  /** Cycle to unenrol from; its course is resolved server-side. */
  cycle_id: string
  /** Learners to unenroll from the cycle; a single-element list covers the single-learner case. Operates on existing individual enrollments (no group expansion). */
  user_ids: string[]
}
export type CsvExportResponseDto = {
  /** Unique identifier for the export request */
  export_id: string
  /** Human-readable message about the export request */
  message: string
  /** Current status of the export request */
  status: string
}
export type TrainingRecordsCsvExportInDto = {
  /** Narrows the export to this course's cycles. Unknown course answers 404. */
  course_code?: string
  /** Narrows the export to this one cycle. Requires course_code; a cycle not belonging to it answers 404. */
  cycle_id?: string
  /** Language the PDF is rendered in. Falls back to the requester's language, then de-DE; an unsupported tag renders de-DE. */
  language_tag?: string
  /** True (default) exports the completion evidence alone; false exports the whole roster, uncompleted learners with an empty completion date. Same switch as the legacy participations export. */
  only_completed?: boolean
}
export type CsvExportStatusDto = {
  /** True if user has an active export (pending or processing) */
  has_active_export: boolean
  /** Timestamp when the export was requested */
  last_requested_at?: string
  /** Status of the active export if one exists */
  status?: string
}
export type ExportStatus = 'pending' | 'processing' | 'completed' | 'completed_with_errors' | 'failed'
export type CsvExportRequestModel = {
  archived_at?: string
  created_at?: string
  download_url?: string
  download_url_expires_at?: string
  error_message?: string
  export_type: string
  file_size_bytes?: number
  filters?: object
  id: string
  language_tag: string
  processing_completed_at?: string
  processing_started_at?: string
  requested_by_user_id: string
  row_count?: number
  s3_bucket?: string
  s3_key?: string
  status?: ExportStatus
  tenant_id: string
  updated_at?: string
}
export const {
  useDownloadTrainingRecordsCsvExportJwtQuery,
  useListTenantCoursesQuery,
  useGetTenantCourseQuery,
  useListTrainingCyclesQuery,
  useCreateTrainingCycleMutation,
  useDeleteTrainingCycleMutation,
  useGetTrainingCycleQuery,
  useUpdateTrainingCycleMutation,
  useListTrainingCycleEmailsQuery,
  useResetTrainingCycleEmailMutation,
  useResetTrainingCycleEmailLanguageMutation,
  useSaveTrainingCycleEmailMutation,
  useSendTestTrainingCycleEmailMutation,
  useListEnrollmentsQuery,
  useCreateEnrollmentsMutation,
  useListEnrollmentFilterOptionsQuery,
  useRemoveEnrollmentsMutation,
  useForceCompleteEnrollmentMutation,
  usePreviewTrainingCycleNextNotificationQuery,
  useSendCycleReminderMutation,
  useExportTrainingCycleRecordsPdfMutation,
  useGetTenantCourseLanguagesQuery,
  usePreviewNewTrainingCycleNextNotificationQuery,
  useListTenantCourseVariantsQuery,
  useListEnrollmentGroupOptionsQuery,
  usePreviewEnrollmentGroupsQuery,
  useCreateEnrollmentsBatchMutation,
  useRemoveEnrollmentsBatchMutation,
  useExportGlobalTrainingRecordsCsvMutation,
  useListTenantTrainingCyclesQuery,
  useExportTrainingRecordsCsvMutation,
  useGetMyTrainingRecordsExportStatusQuery,
  useGetTrainingRecordsCsvExportStatusQuery,
  useDownloadTrainingRecordsCsvExportQuery,
} = injectedRtkApi
